<template>
  <div>
    <Head :title="form.name" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item"><Link href="/settings/airports">Airports</Link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ form.name }}</li>
      </ol>
    </nav>
    <h1>
      {{ form.name }}
    </h1>
    <trashed-message v-if="airports.deleted_at" class="mb-6" @restore="restore"> This airport has been deleted. </trashed-message>
    <div class="content-box">
      <form @submit.prevent="update">
        <AirportForm :form="form" />

        <div class="actions-toolbar d-flex justify-content-between">
          <button v-if="!airports.deleted_at" class="btn btn-outline-danger" tabindex="-1" type="button" @click="destroy">Delete Airport</button>
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Update Airport</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import AirportForm from './components/AirportForm'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    AirportForm,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    airports: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.airports.name,
        island_city: this.airports.island_city,
        city: this.airports.city,
        country: this.airports.country,
        iata: this.airports.iata,
        icao: this.airports.icao,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/settings/airports/${this.airports.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this airport?')) {
        this.$inertia.delete(`/settings/airports/${this.airports.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this airport?')) {
        this.$inertia.put(`/settings/airports/${this.airports.id}/restore`)
      }
    },
  },
}
</script>
